import { getSortedFormFields } from '@utils/forms';
import { helpWithOptions } from './GreenLakeSupportGLCPFormOptions';

export const getGreenLakeSupportGLCPFormData = (target, helpWith) => {
  let namespace: string;
  let subject: string;

  switch (helpWith) {
    case helpWithOptions.api:
    case helpWithOptions.commerceApi:
      namespace = 'hpe_partner_api';
      subject = `API : ${helpWith} - {formId}`;
      break;
    case helpWithOptions.localGateway:
      namespace = 'hpe_localgateway';
      subject = `Local Gateway : ${helpWith} - {formId}`;
      break;
    case helpWithOptions.newSubscriptionOrder:
      namespace = 'hpe_glcp_buyexperience';
      subject = `Buy Experience : ${helpWith} - {formId}`;
      break;
    case helpWithOptions.supportHub:
      namespace = 'hpe_supporthub';
      subject = `GL Platform Services : ${helpWith} - {formId}`;
      break;
    default:
      namespace = 'hpe_greenlake_user';
      subject = `GL Platform Services : ${helpWith} - {formId}`;
  }

  return getSortedFormFields(target, namespace, subject);
};
